import React from 'react';
import { observer } from 'mobx-react';

import { ComponentBase, InjectedStyledComponent } from '../../../../../shared/index.js';
import Image from '../../../../base/Image/Image.js';
import { ISvgPolygonProps } from '../../../../svg/SvgPolygon/models/index.js';
import { SvgPolygon } from '../../../../svg/SvgPolygon/SvgPolygon.js';

import { ISeriesPointConfiguration, ISeriesPointProps, ISeriesPointState } from './models/index.js';
import {
	SERIES_POINT_CATEGORY_KEY,
	SERIES_POINT_COMPONENT_KEY,
	SERIES_POINT_PARENT_COMPONENT_KEY,
} from './SeriesPoint.meta.js';

export class SeriesPoint extends ComponentBase<ISeriesPointProps, ISeriesPointState, ISeriesPointConfiguration> {
	categoryKey = SERIES_POINT_CATEGORY_KEY;
	componentKey = SERIES_POINT_COMPONENT_KEY;
	get parentComponentKey(): string | undefined {
		return SERIES_POINT_PARENT_COMPONENT_KEY;
	}

	constructor(props: ISeriesPointProps) {
		super(props);
	}

	getNumber(val: string | number) {
		return typeof val === 'string' ? parseInt(val, 10) : val;
	}

	render() {
		const {
			children,
			position,
			type,
			svgProps = {},
			imageProps = {},
			configuration,
			componentStyle,
			...otherProps
		} = this.props;

		let point;
		if (type === 'dynamicSvg') {
			const { size = 10, color, borderColor, borderThickness } = svgProps;
			const svgSize = this.getNumber(size);
			let points: ISvgPolygonProps['points'];
			if (position === 'top') {
				points = [
					{ x: 0, y: 0 },
					{ x: svgSize, y: 0 },
					{ x: svgSize / 2, y: svgSize },
				];
			} else {
				points = [
					{ x: svgSize / 2, y: 0 },
					{ x: svgSize, y: svgSize },
					{ x: 0, y: svgSize },
				];
			}
			const props: ISvgPolygonProps = {
				points,
				baseSvgProps: {
					width: svgSize,
					height: svgSize,
					fill: color,
					stroke: borderColor,
					strokeWidth: borderThickness,
				},
			};
			point = <SvgPolygon {...props} />;
		} else {
			point = <Image {...imageProps} />;
		}
		return <div {...otherProps}>{point}</div>;
	}
}

export default InjectedStyledComponent(
	observer(SeriesPoint),
	SERIES_POINT_CATEGORY_KEY,
	SERIES_POINT_PARENT_COMPONENT_KEY,
	[SERIES_POINT_COMPONENT_KEY],
);
